"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@apollo/client");
const ui_1 = require("@mapmaker/ui");
const FaEye_1 = require("@react-icons/all-files/fa/FaEye");
const FaEyeSlash_1 = require("@react-icons/all-files/fa/FaEyeSlash");
const MapmakerApi_1 = require("../../../../../client/MapmakerApi");
const gtm_1 = require("../../../../../lib/gtm");
const fileReducer_1 = require("../../../fileReducer");
const projectStore_1 = require("../../../projectStore");
const useProjectToastMessages_1 = require("../../../shared/toasts/useProjectToastMessages");
(0, client_1.gql) `
  mutation hideOpeningSuggestion($input: HideOpeningSuggestionInput!) {
    hideOpeningSuggestion(input: $input) {
      suggestion {
        ...OpeningSuggestion
      }
    }
  }
`;
function HideSuggestionButton(_a) {
    var { suggestion, onHidden = () => { } } = _a, buttonProps = __rest(_a, ["suggestion", "onHidden"]);
    const projectDispatch = (0, projectStore_1.useProjectDispatch)();
    const isHidden = suggestion.status === MapmakerApi_1.OpeningSuggestionStatus.Hidden;
    const toast = (0, useProjectToastMessages_1.useAddToastMessage)();
    const [hideSuggestion] = (0, MapmakerApi_1.useHideOpeningSuggestionMutation)({
        onError: () => toast.addToastError("Error hiding suggestion."),
    });
    const onClick = (e) => __awaiter(this, void 0, void 0, function* () {
        e.stopPropagation();
        const hiding = !isHidden;
        // Optimistically hide this.
        projectDispatch((0, fileReducer_1.updateOpeningSuggestion)(Object.assign(Object.assign({}, suggestion), { status: hiding
                ? MapmakerApi_1.OpeningSuggestionStatus.Hidden
                : MapmakerApi_1.OpeningSuggestionStatus.Submitted })));
        (0, gtm_1.trackGtmEvent)({
            event: "mapmaker.manually-toggle-suggestion-hidden",
            openingId: suggestion.openingId,
            hidden: hiding,
        });
        if (hiding) {
            toast.addToastInfo({
                content: "Suggestion hidden.",
                icon: FaEyeSlash_1.FaEyeSlash,
            }, undefined, 3);
        }
        yield hideSuggestion({
            variables: {
                input: {
                    openingId: suggestion.openingId,
                    fileId: suggestion.fileId,
                    id: suggestion.id,
                    hide: hiding,
                },
            },
        });
        onHidden();
    });
    return ((0, jsx_runtime_1.jsxs)(ui_1.Button, Object.assign({ onClick: onClick }, buttonProps, { children: [isHidden && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FaEyeSlash_1.FaEyeSlash, {}), " Unhide"] })), !isHidden && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FaEye_1.FaEye, {}), " Hide"] }))] })));
}
exports.default = HideSuggestionButton;
//# sourceMappingURL=data:application/json;base64,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